export default function toArray(arrayLike) {
   const res = [];
   for (let i = 0; i < arrayLike.length; i++) {
      res.push(arrayLike[i]);
   }
   return res;
}
